import { render } from "./safariPushPrompt.vue?vue&type=template&id=949977de&scoped=true"
import script from "./safariPushPrompt.vue?vue&type=script&lang=js"
export * from "./safariPushPrompt.vue?vue&type=script&lang=js"

import "./safariPushPrompt.vue?vue&type=style&index=0&id=949977de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-949977de"]])

export default __exports__